export default "__VITE_ASSET__V0KPm607__"